module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/scandal.23664e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/scandal.jpg
// module id = Eqq6
// module chunks = 0